import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { urlValidation } from 'utils/patterns';
import { ImageUploader } from 'components/Core/ImageUploader/ImageUploader';
import { TableActionsButtons } from 'components/RequestsComponents/TableActionsButtons';
import { ControlledInput } from 'components/Inputs/ControlledInput';
import RequestHeader from 'components/RequestsComponents/RequestHeader';
import { IBrandRequestData } from 'stores/requests/types';
import { brandRequestFormTranslations } from './translations';
import { BrandRequestFormTransFields } from './types';
import styles from './brandRequestForm.module.scss';

export const BrandRequestForm: FC = observer(() => {
  const {
    requestsStore: { brandRequestData },
  } = useStore();

  const { t } = useMyTranslations<BrandRequestFormTransFields>([brandRequestFormTranslations.name]);

  const useFormMethods = useForm<IBrandRequestData>({
    defaultValues: brandRequestData || undefined,
  });

  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors }, // should create errors conts to update errors when they appears
  } = useFormMethods;

  return brandRequestData ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <FormProvider {...(useFormMethods as any)}>
      <RequestHeader>
        <TableActionsButtons id={brandRequestData.id} entity='brands' status={brandRequestData.status} />
      </RequestHeader>
      <div className={styles.content}>
        <form className={styles.form}>
          <section className={`${styles.leftSection}`}>
            <div className={`${styles.formSection}`}>
              <h6 className={`${styles.title} ${styles.titleWithMargin}`}>{t('title')}</h6>
              <ControlledInput
                name='name'
                type='text'
                label={t('name')}
                disabled
                classNameProp={brandRequestData.changedFieldsNames.includes('name') ? styles.highlight : undefined}
              />
              <ControlledInput
                name='website'
                type='text'
                label={t('website')}
                validation={urlValidation()}
                disabled
                classNameProp={brandRequestData.changedFieldsNames.includes('website') ? styles.highlight : undefined}
              />
            </div>
          </section>
          <section className={styles.rightSection}>
            <ImageUploader
              name='logoUrl'
              title={t('logoUrl')}
              path='brands'
              disabled
              classNameProp={brandRequestData.changedFieldsNames.includes('logoUrl') ? styles.highlight : undefined}
            />
            <ImageUploader
              name='pointerUrl'
              title={t('pointerUrl')}
              path='brands-markers'
              disabled
              classNameProp={brandRequestData.changedFieldsNames.includes('pointerUrl') ? styles.highlight : undefined}
            />
          </section>
        </form>
      </div>
    </FormProvider>
  ) : (
    <p>No such brand was found</p>
  );
});
